export interface UserProfile {
  firstName: string;
  lastName: string;
  userId: string;
  jsessionId: string;
  officeId: string;
  organizationId: string;
  language: string; // TODO check if we can remove this field
}

export const EMPTY_USER_PROFILE: UserProfile = {
  firstName: '',
  lastName: '',
  userId: '',
  jsessionId: '',
  officeId: '',
  organizationId: '',
  language: 'EN'
};
